export default __webpack_public_path__ + "static/media/light_high_light.1544ff23.svg";